import React, { useRef, useState } from "react";
import styles from "../../../styles/pages/botStore.module.scss";
import { getBotsAction, getFilterBotsAction } from "../../../redux/storeBot/actions";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroller";
import { useRouter } from "next/router";
import _ from "lodash";
import _get from "lodash/get";
import { imageBaseURL } from "../../../data/createBotForm";
import { getFilterListAction, getProductAction } from "../../../redux/products/actions";
import endpoints from "../../../utility/endpoints";
import dynamic from "next/dynamic";
const Banner = dynamic(() => import("../../cezBanner/index"));
import Icons from "../../../public/assets/svg";
import CLose from "../../../public/assets/svg";
import Loader from "../../Loader";
import Addproduct from './Addproduct'
import { Button, Collapse, Divider, Radio, Space } from 'antd';
import { DownOutlined, EditOutlined, DeleteOutlined, PlusOutlined, SaveOutlined, CloseOutlined} from '@ant-design/icons';
import axios from "axios";



// import MobileFilters from '../../MobileFilters'
const { Panel } = Collapse;
function index(props) {
let pagenumber;

  const dispatch = useDispatch();
  let size = 9
  const [totalPage, settotalPage] = useState(0)
  const [page, setpage] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [showMore, setShowMore] = useState(false);
  const myScroll = useRef(null);

  const router = useRouter();
  const { data } = props;
  const bannerData = _.get(data[0], "component.content", "")

  //  const {component : {content }} = data[1]
  const content = _.get(data[1], "component.content", "");
  // _.get(data[2], "component.content.field_no_result_image[0].file_url", "")
  let initialStates = {};
  let [state, setState] = React.useState(initialStates);

  let [allProducts, setallProducts] = React.useState([]);
  let [filters, setFilters] = React.useState([]);
  const [filterOn, setFilterOn] = useState(false);
  const [hasMore, setHasMore] = React.useState(true);
  const [filterActive, setFilterActive] = React.useState(false)
  const [auth, setAuth] = useState({});
  const [infiniteKey, setInfiniteKey] = React.useState(1)
  const [noResultFlag, setNoResultFlag] = React.useState(false)
  const [isHidden, setIsHidden] = useState(true);
  const toggleVisibility = () => {
    setIsHidden(!isHidden);
  };

  const [nonRestrictedUser, setnonRestrictedUser] = useState([
    "admin",
    "internalUser",
    "qrManager",
    "supportStatus"
  ]);
  const goToPage = (link) => {
    const encBotId = window.btoa(link)
    window.open(endpoints.redirectUriLogin + `product_details?prodId=${encBotId}`)
    // router.push('/product_details');
  };
let count=0;
  const [filterStateExport, setfilterStateExport] = useState({})
  const [loadState, setLoadState] = React.useState(false);
  const [hasMoreBots, setHasMoreBots] = React.useState(true);
  const [length, setLength] = useState(0);
  const [loading, setLoading] = React.useState(false);
  const [mobileFilterRelatedInfo, setMobileFilterRelatedInfo] = React.useState({})
  const [totalIndexFilter, setTotalIndexFilter] = React.useState(0)
  const [currentFilters, setCurrentFilters] = React.useState({})
  const [reset, setReset] = React.useState(false)

  const cezDetails = ""
  const cezHeading = "Our Product"
  const backgroundUrl = "/sites/default/files/2021-03/banner-cez-web.png"
  const backgroundUrlMobile = { file_url: '/sites/default/files/2021-03/banner-cez-mobile.png', file_name: 'banner-cez-mobile.png', mime_type: 'image/png', image_alt: 'banner-cez-mobile' }

  const [cardImage, setCardImage] = React.useState("all.svg");

  //  const [businessFilters, setBusinessFilter] = React.useState([{"business_unit_id":1,"cluster":"SEAA"},{"business_unit_id":2,"cluster":"LATAM"},{"business_unit_id":3,"cluster":"North America"},{"business_unit_id":4,"cluster":"Africa"},{"business_unit_id":5,"cluster":"South Asia"},{"business_unit_id":6,"cluster":"South Africa"},{"business_unit_id":7,"cluster":"Europe"},{"business_unit_id":8,"cluster":"NAMETRUB"},{"business_unit_id":9,"cluster":"North America"},{"business_unit_id":10,"cluster":"Global"},{"business_unit_id":11,"cluster":"North Asia"}])
  //  const [functionFilters, setFunctionFilter] = React.useState([{"function_id":1,"function_name":"Supply Chain"},{"function_id":2,"function_name":"Finance"},{"function_id":3,"function_name":"Customer Development"},{"function_id":4,"function_name":"Marketing"},{"function_id":5,"function_name":"R&D"},{"function_id":6,"function_name":"HR"},{"function_id":7,"function_name":"IT Services"}])
  //  const [subAreaFilters, setSubAreaFilter] = React.useState([{"sub_area_id":1,"sub_area":"Procurement"},{"sub_area_id":2,"sub_area":"Mask"},{"sub_area_id":3,"sub_area":"Deliver"},{"sub_area_id":4,"sub_area":"Customer Services"},{"sub_area_id":5,"sub_area":"R2R"},{"sub_area_id":6,"sub_area":"P2P"},{"sub_area_id":7,"sub_area":"Reporting"},{"sub_area_id":8,"sub_area":"Marketing"},{"sub_area_id":9,"sub_area":"R&D"},{"sub_area_id":10,"sub_area":"HR"},{"sub_area_id":11,"sub_area":"IT Services"}, {"sub_area_id":12,"sub_area":"Customer Development"}])
   const [businessFilters, setBusinessFilter] = React.useState([]);
   const [functionFilters, setFunctionFilter] = React.useState([]);
   const [subAreaFilters, setSubAreaFilter] = React.useState([]);

   const [addEditBusinessFlag, setAddEditBusinessFlag] = React.useState(false);
   const [addEditFunctionFlag, setAddEditFunctionFlag] = React.useState(false);
   const [addEditSubAreaFlag, setAddEditSubAreaFlag] = React.useState(false);

   const [addEditBusiness, setAddEditBusiness] = React.useState({"business_unit_id":-1, "cluster":""});
   const [addEditFunction, setAddEditFunction] = React.useState({"function_id":-1,"function_name":""});
   const [addEditSubArea, setAddEditSubArea] = React.useState({"sub_area_id":-1,"sub_area":""});

   const [filterRadio, setFilterRadio] = React.useState({"cluster": "", "catalog_products": "", "sub_area": ""});



   React.useEffect(() => {

    //console.log(state, "statefirstaa")
  //   let Filters = {};
  //   for (let i in state) {
  //     if (state[i]) {
  //       if (state[i].length > 0) {
  //         Filters[i] = state[i];
  //       }
  //     }
  //   }
  //   setfilterStateExport(Filters);


  //   if (
  //     Filters &&
  //     Object.keys(Filters).length === 0 &&
  //     Filters.constructor === Object
  //   ) {
  //     if (props.storeBot.filter !== null){
  //     window.scrollTo(0,200)
  //   }
  //     setLoading(true);  
  //     setInfiniteKey(infiniteKey+1)
  //     dispatch(getBotsAction(0))
  //     setHasMoreBots(true)
  //     setLoadState(true)
  //     setSearch("")

  //   }

  // else {
  //   setLoading(true);  
  //   setInfiniteKey(infiniteKey+1)
  //   setHasMoreBots(true)
  //   setLoadState(true)
  //   window.scrollTo(0,200)
  //   setCurrentFilters(Filters)
  //   dispatch(getFilterBotsAction(0, Filters));

  // }


    }, [state]);
  const addTofilters=(e,k,v)=>{
    //console.log("addtofilters",e?.target?.checked,k,v)
    let obj={...state}
    if(obj.hasOwnProperty(k)){
      delete obj[k];
    }
    if(e?.target?.checked){
      obj[k]=[v];
    }
    setState(obj);
    setFilterRadio(old=>({...old,[k]: v}));
    // if(e.target.checked){
    //   let obj={...state}
    //   if(obj.hasOwnProperty(k)){
    //     obj[k]=[...obj[k],v]
    //   }else{
    //     obj[k]=[v]
    //   }
    //   setState(obj)
    // }else{
    //   let obj={...state}
    //   if(obj.hasOwnProperty(k)){
    //     const ind=Array.isArray(obj[k])&& [...obj[k]].findIndex((val)=>v==val)
    //     if(ind>=0){
    //     console.log("obj[k]11")
    //       obj[k].splice(ind,1)
    //       if(obj[k].length==0){
    //         delete obj[k]
    //       }
    //     }
    //   setState(obj)

    //   }
    // }
  }
  const isChecked=(k,v)=>{
    if(state.hasOwnProperty(k)){
      const id=state[k].findIndex((val)=>v===val)
      if(id>=0){
    //console.log("true")
        return true
      }else{
    //console.log("false")

        return false
      }
    }else{
      //console.log("false1")
      return false
    }
  }

  React.useEffect(() => {
    //console.log("storeProduct", props?.storeProduct)
    if (props?.storeProduct?.allProducts && props?.storeProduct?.filter !== null) {
      if (props?.storeProduct?.allProducts?.length == 0) {
        setNoResultFlag(true)
      }
      setLoading(false);
      setTotalIndexFilter(props?.storeProduct?.length)
      setallProducts([...props?.storeProduct?.allProducts]);
      settotalPage(props?.storeProduct?.allProducts?.length)
      setFilters(props?.storeProduct?.filterList)
      let totalRec = props?.storeProduct?.totalRecords / size
      let arr = []
      //console.log("totalRec", totalRec)
      if (totalRec > 1) {
        for (let index = 0; index < totalRec; index++) {
          arr?.push(index + 1);
        }
        setpage(arr)
      } else if (totalRec > 0) {
        setpage([1])

      }
      setHasMoreBots(true)
      setLoadState(true);
      if (state?.search && state?.search?.length > 0) {
        inputRef?.current?.focus()
      }

    }
  }, [props.storeProduct]);









  // const loadFunc = (a) => {
  //       console.log(props.storeBot.totalIndex, "totalIndex")
  //       if (allBots.length < totalIndexFilter) {
  //         setHasMoreBots(true)
  //         setLoadState(true)
  //         if (!props.storeBot.filter)  {

  //           dispatch(getBotsAction(a));
  //           setLoadState(false)
  //         }
  //         else {

  //           dispatch(getFilterBotsAction(a, currentFilters))
  //           setLoadState(false)
  //         }

  //       } else {
  //       //  setLoadState(false)
  //         setHasMoreBots(false)
  //        // setHasMoreBots(false)
  //       }
  // };



  const clearALLFilter = () => {
    window.scrollTo(0, 200)
    setState({})
    //setLoadState(true)
    setNoResultFlag(false)
    setSearchValue("");


    // dispatch(getBotsAction(0))
    // setAllBots([])
    // setInfiniteKey(infiniteKey + 1)
    // setHasMoreBots(true)


  };
  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }


  const removeFilter = (keyname) => {
    if (keyname == "leadPlatform") {
      setReset(true)
      let otherState = mobileFilterRelatedInfo
      delete otherState['Area']
      setMobileFilterRelatedInfo({ ...otherState })
    }
    let stateToChange = state
    let itemToBeRemoved = content?.field_bot_store_filters_fields?.filter((item) => item?.value == keyname)
    if (itemToBeRemoved?.length > 0) {
      if (itemToBeRemoved[0]?.field_related_dropdown) {
        delete stateToChange[camelize(itemToBeRemoved[0].field_related_dropdown)]
      }

    }


    delete stateToChange[keyname]

    setState({ ...stateToChange });
    if (length > 0) {
      setLength(length - 1);
    }

  };

  const inputRef = useRef(null)
  const [reload, setReload] = useState(false);
  const [search, setSearch] = useState(state.search)


  const { query } = useRouter();

  const isTabOneSelected = !!query?.tabOne;
  const isTabTwoSelected = !!query?.tabTwo;
  const isTabThreeSelected = !!query?.tabThree;


  React.useEffect(() => {
    if (reload) {
      setState({ ...state, ["search"]: search });
      setReload(false)

    }

  }, [reload]);
  React.useEffect(async()=>{
    dispatch(getFilterListAction());
  },[])
  React.useEffect(async () => {
    // state = { ...router.query };
    setLoading(true);
    dispatch(getProductAction({ currentPage: currentPage, size: size, filter: state }));
    // dispatch(getFilterListAction());

    try {
      if (localStorage.getItem("auth") != undefined) {
        setAuth(JSON.parse(localStorage.getItem("auth").data));
      }
    } catch (e) { }
  }, [currentPage,state]);

  const callApi = () => { setReload(true) }; // You might be able to call API directly here, I haven't tried
  const [debouncedCallApi] = useState(() => _.debounce(callApi, 800));

  const inputChange = (e) => {
    if (e?.target?.value?.length == 0) {
      //  console.log(e.target.value, "before");
      let statess = state;
      delete statess?.search;
      setSearch("")
      setState({ ...statess })
      if (_.isEmpty(statess)) {
        clearALLFilter();

      }
    } else {

      setSearch(e?.target?.value)
      debouncedCallApi()

    }

  };

  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
    // console.log(index);
  }

  const [addProduct, setAddProduct] = useState(false);

  // console.log("statestate", state);
  const [searchValue, setSearchValue] = useState("");

  const searchProduct = () => {
    setLoading(true);
    dispatch(getProductAction({ currentPage: "", size: "", filter: {product_title:searchValue} }));
  }

  const deleteBusinessFilter = async (id) => {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      try {
        const businessResponse = await axios({
          method: "POST",
          url: `${endpoints.baseUrl}${'/task/deleteBusinessUnit'}`,
          // url: "http://localhost:4550/node/api/task/deleteBusinessUnit",

          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
          data: 
          {
              "business_unit_id": id,
          }
        });
        getFilterData();

      } catch (e) {
        console.log("failed to delete Business filter "+e);
      }
    
  };

  const deleteFunctionFilter = async (id) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    try {
      const businessResponse = await axios({
        method: "POST",
        url: `${endpoints.baseUrl}${'/task/deleteFunctionFilters'}`,
        // url: "http://localhost:4550/node/api/task/deleteFunctionFilters",
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        data: 
        {
            "function_id": id,
        }
      });
      getFilterData();
    } catch (e) {
      console.log("failed to delete Function filter "+e);
    }
  
};

const deleteSubAreaFilter = async (id) => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  try {
    const businessResponse = await axios({
      method: "POST",
      url: `${endpoints.baseUrl}${'/task/deleteSubAreaFilter'}`,
      // url: "http://localhost:4550/node/api/task/deleteSubAreaFilter",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
      data: 
      {
          "sub_area_id": id,
      }
    });
    getFilterData();
  } catch (e) {
    console.log("failed to delete SubArea filter "+e);
  }

};
  const onFilterAdd = (type) => {
    if(type=== "Business"){
      setAddEditBusinessFlag(true);
      setAddEditBusiness({"business_unit_id": -1, "cluster": ""});

    }
    else if(type=== "Function") {
      setAddEditFunctionFlag(true);
      setAddEditFunction({"function_id": -1, "function_name": ""});
    }

    else {
      setAddEditSubAreaFlag(true)
      setAddEditSubArea({"sub_area_id": -1, "sub_area": ""});
    }

  }

  const onFilterEdit = (type, item) => {
    if(type === "Business"){
      setAddEditBusinessFlag(true);
      setAddEditBusiness(item);

    }
    else if(type=== "Function") {
      setAddEditFunctionFlag(true);
      setAddEditFunction(item);
    }

    else {
      setAddEditSubAreaFlag(true)
      setAddEditSubArea(item);
    }

  }

  const onFilterSave = async (type) => {
    if(type=== "Business"){
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        let body = {...addEditBusiness};
        try {
            
          const response = await axios({
            method: "POST",
            url: `${endpoints.baseUrl}${'/task/createOrUpdateBusinessUnit'}`,
            // url: "http://localhost:4550/node/api/task/createOrUpdateBusinessUnit",
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
            data: body,
          });
          getFilterData();
          onFilterClear(type);
        } catch (e) {
          console.log("failed to create/update Business Filter"+e);
        }
    }
    else if(type=== "Function") {
      //console.log(addEditFunction)
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        let body = {...addEditFunction};
        try {
            
          const response = await axios({
            method: "POST",
            url: `${endpoints.baseUrl}${'/task/createOrUpdateFunctionFilter'}`,
            // url: "http://localhost:4550/node/api/task/createOrUpdateFunctionFilter",
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
            data: body,
          });
          getFilterData();
          onFilterClear(type);
        } catch (e) {
          console.log("failed to create/update Filter Filter"+e);
        }
    }

    else {
      //console.log(addEditSubArea)
      let auth = JSON.parse(localStorage.getItem("auth")).data;
        let body = {...addEditSubArea};
        try {
            
          const response = await axios({
            method: "POST",
            url: `${endpoints.baseUrl}${'/task/createOrUpdateSubAreaFilters'}`,
            // url: "http://localhost:4550/node/api/task/createOrUpdateSubAreaFilters",
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
            data: body,
          });
          getFilterData();
          onFilterClear(type);
        } catch (e) {
          console.log("failed to create/update SubArea Filter"+e);
        }
    }

  }

  const onFilterClear = (type) => {
    if(type=== "Business"){
      setAddEditBusinessFlag(false);
      setAddEditBusiness({"business_unit_id": -1, "cluster": ""});

    }
    else if(type=== "Function") {
      setAddEditFunctionFlag(false);
      setAddEditFunction({"function_id": -1, "function_name": ""});
    }

    else {
      setAddEditSubAreaFlag(false)
      setAddEditSubArea({"sub_area_id": -1, "sub_area": ""});
    }

  }

  React.useEffect(async()=>{
    getFilterData()
  },[])

  const getFilterData = async () => {
    try {

      const response = await axios({
        method: "GET",
        url: `${endpoints.baseUrl}${'/task/getFilterData'}`,
        // url: "http://localhost:4550/node/api/task/getFilterData",
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      });
      if(response)
      {
          setBusinessFilter(response?.data?.data?.business_array);
          setFunctionFilter(response?.data?.data?.function_array);
          setSubAreaFilter(response?.data?.data?.subarea_array);

      }
    } catch (e) {
      console.log("failed to get Filters data"+e);
    }
  }

  const setFunctionIcon = (type) => 
  {
    if(type === "All")
    {
     // clearALLFilter();
      // setState({"catalog_products":["All"]});
      setCardImage("all.svg")
    }
    else if(type === "Finance")
    {
     // setState({"catalog_products":[type]});
      setCardImage("finance.svg")
    }
    else if(type === "IT Services")
    {
     // setState({"catalog_products":[type]});
      setCardImage("hr.svg")
    }
    else if(type === "Legal")
    {
     // setState({"catalog_products":[type]});
      setCardImage("legal.svg")
    }
    else if(type === "Supply Chain")
    {
     // setState({"catalog_products":[type]});
      setCardImage("supply.svg")
    }
    else if(type === "Marketing")
    {
     // setState({"catalog_products":[type]});
      setCardImage("marketing.svg")
    }
    else if(type === "Customer Development")
    {
     // setState({"catalog_products":[type]});
      setCardImage("customer.svg")
    }
    else
    {
     // setState({"catalog_products":[type]});
      setCardImage("all.svg")
    }

  }
//console.log("current page==>",currentPage*9-9);

  return (
    <>
      {!addProduct ? <div key={infiniteKey}>
        {/* <InfiniteScroll
        key = {infiniteKey}
          pageStart={0}
          loadMore={loadState ? loadFunc : null}
          hasMore={hasMoreBots}
          loader={
            <div className={styles.loader}>
              <div className={styles.spinner}></div>
            </div>
          }
        > */}


        {loading ? (
          <div style={{ height: "800px" }}>
            <Loader />
          </div>
        ) : <div className={styles.storeContainer}>
          <div className={styles.mainSection_space}>
            <div className={styles.banner_card_section}>
              <img className={styles.frist_image} src={`${imageBaseURL}banner-product.png`} alt="" />
              <div className="m-auto">
                <h1>Our Products</h1>
                <p >Our ready-to-deploy solutions called “Products” can reduce your automation timeline from 8 to 12 weeks to just a week!.</p>
              </div>
              <img className={styles.second_image} src={`${imageBaseURL}banner-product2.png`} alt="" />
            </div>
          </div>
          {/* <div className="mt-4 mb-4">
            <ul className={styles.flex_section}>
              <li style={Object.keys(state).length===0 ?{backgroundColor:'#1F36C7'}:{backgroundColor:'#fff'}} onClick={()=>{clearALLFilter();setCardImage("all.svg")}}>All</li>
              <li style={isChecked('catalog_products','Finance')?{backgroundColor:'#1F36C7'}:{backgroundColor:'#fff'}} onClick={()=>{setState({"catalog_products":["Finance"]});setCardImage("finance.svg")}}>Finance</li>
              <li style={isChecked('catalog_products','IT Services')?{backgroundColor:'#1F36C7'}:{backgroundColor:'#fff'}} onClick={()=>{setState({"catalog_products":["IT Services"]}); setCardImage("hr.svg")}}>IT Services</li>
              <li style={isChecked('catalog_products','Legal')?{backgroundColor:'#1F36C7'}:{backgroundColor:'#fff'}} onClick={()=>{setState({"catalog_products":["Legal"]});setCardImage("legal.svg")}}>Legal</li>
              <li style={isChecked('catalog_products','Supply Chain')?{backgroundColor:'#1F36C7'}:{backgroundColor:'#fff'}} onClick={()=>{setState({"catalog_products":["Supply Chain"]}); setCardImage("supply.svg")}}>Supply Chain</li>
              <li style={isChecked('catalog_products','Marketing') ?{backgroundColor:'#1F36C7'}:{backgroundColor:'#fff'}} onClick={()=>{setState({"catalog_products":["Marketing"]}); setCardImage("marketing.svg")}}>Marketing</li>
              <li style={isChecked('catalog_products','Customer Development')?{backgroundColor:'#1F36C7'}:{backgroundColor:'#fff'}} onClick={()=>{setState({"catalog_products":["Customer Development"]}); setCardImage("customer.svg")}}>Customer Development</li>
            </ul>
          </div> */}
          {/* <div className={`mt-5` }>
             <img style={{width:'100%',height:'480.74px',objectFit:'cover'}} src={`${imageBaseURL}main-product.gif`} />
            </div> */}
        
          <div className={styles.mainContainersection}>
            <main className={`${styles.mainContainer2}`}>
              <div className="row" >
               {!isHidden &&  
                <div className="col-md-3">
                  <div className={styles.filters_card}>
                    <div className={styles.filters_card_section}>
                      <div>
                        <p style={{cursor:"pointer"}} onClick={()=>searchProduct()}>Filters</p>
                      </div>
                      <div className="d-flex">
                        <div>
                          {/* <CLose name="searchGrayIcon" className={styles.searchIcon} /> */}
                        </div>
                        <p onClick={()=>clearALLFilter()} style={{cursor:"pointer"}}>Clear All</p>
                      </div>
                    </div>
                    <div style={{ position: "relative" }}>
                      <input className={`${styles.search_section} mb-3`}
                        type="text"
                        placeholder="Search by Product Title"
                        onChange={(e)=> setSearchValue(e.target.value)}
                        value={searchValue}
                        onKeyPress ={(e)=> {
                          if(e.key === "Enter") {
                            searchProduct()
                          }
                        }} 
                      />
                      <Icons name="searchGrayIcon" className={styles.searchIcon} />
                    </div>

                    {/* {filters.map((v, idx) => {
                      return (
                        <div>
                          {
                            <>
                              <p className="mb-3 mt-5" >{"Business Units"}</p>
                              <div className="row mb-2 ml-0">{
                                [...new Map(v.value.map(it =>
                                  [it[v.key], it])).values()].filter((vv)=>vv[v.key]!=="").map((v1) => {
                                  return (
                                    // <div className="col-12 ">
                                      <div className={`${styles.checlk_list}d-flex  mr-2`}>
                                        <input type="checkbox" multiple="false" checked={isChecked(v.key,v1[v.key])} id={idx} onClick={(e)=>addTofilters(e,v.key,v1[v.key])} name={v1[v.key]} value={v1[v.key]} className="mr-1"/>
                                        <label for="vehicle1">{v1[v.key]}</label>
                                      </div>
                                    // </div>
                                  )
                                })
                              }</div>
                            </>
                          }
                        </div>
                      )
                    })} */}

                    { props.userRole === "admin" && <div>
                      <Collapse defaultActiveKey={[]} expandIconPosition={"end"} expandIcon={({isActive}) => <DownOutlined rotate={isActive ? -180 : 0} />}>
                        <Panel header="Business Units" key="1" >
                        { !addEditBusinessFlag && <div style={{height:50, width:"100%", display: "flex", justifyContent: "end"}}>
                          <Button color="primary" style={{color:"#1f36c7", border:"none"}} icon={<PlusOutlined />} onClick={()=>onFilterAdd("Business")}> Add Business </Button>
                        </div> } 
                        {addEditBusinessFlag && <div className="add-filters" style={{height:50, width:"100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                              <div className="add-filters-input" style={{width: "75%"}}>
                                  <input placeholder="Enter Business Unit" style={{width: "100%", padding: "2px 15px", borderRadius: 5}} type={"text"} value={addEditBusiness.cluster} onChange={(e)=> {setAddEditBusiness(old=> ({...old, "cluster": e.target.value}))}}/>
                              </div>
                              <div className="add-filters-action" style={{width: "22%"}}>
                                <Button style={{color:"#1f36c7", border:"none"}} icon={<SaveOutlined />} onClick={()=>onFilterSave("Business")}></Button>
                                <Button style={{color:"#1f36c7", border:"none"}} icon={<CloseOutlined />} onClick={()=>onFilterClear("Business")}></Button>
                              </div>
                          </div>}
                          <Radio.Group onChange={()=> {}} style={{width: "100%"}} value={filterRadio.cluster}>
                            <Space direction="vertical" style={{width: "100%"}}>
                              {businessFilters?.map((item, idx) => {
                                  return <>
                                    <div className="radio-items" style={{display:'flex', justifyContent: "space-between"}}>
                                      <Radio className="radio" style={{width: "75%"}} value={item.cluster} onClick={(e)=> addTofilters(e, "cluster", item.cluster)}>{item.cluster}</Radio>
                                      <div className="action-buttons" style={{width: "22%"}}>      
                                        <Button style={{color:"#1f36c7", border:"none"}} icon={<EditOutlined />} onClick={()=> onFilterEdit("Business", item)}></Button>
                                        <Button style={{color:"red", border:"none"}} icon={<DeleteOutlined />} onClick={()=>deleteBusinessFilter(item.business_unit_id)}></Button>
                                      </div>
                                    </div>
                                  </>
                              })}
                            </Space>
                          </Radio.Group>
                        </Panel>
                        <Panel header="Function" key="2" >
                        { !addEditFunctionFlag && <div style={{height:50, width:"100%", display: "flex", justifyContent: "end"}}>
                          <Button color="primary" style={{color:"#1f36c7", border:"none"}} icon={<PlusOutlined />} onClick={()=>onFilterAdd("Function")}> Add Function </Button>
                        </div> } 
                        {addEditFunctionFlag && <div className="add-filters" style={{height:50, width:"100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                              <div className="add-filters-input" style={{width: "75%"}}>
                                  <input placeholder="Enter Function" style={{width: "100%", padding: "2px 15px", borderRadius: 5}} type={"text"} value={addEditFunction.function_name} onChange={(e)=> {setAddEditFunction(old=> ({...old, "function_name": e.target.value}))}}/>
                              </div>
                              <div className="add-filters-action" style={{width: "22%"}}>
                                <Button style={{color:"#1f36c7", border:"none"}} icon={<SaveOutlined />} onClick={()=>onFilterSave("Function")}></Button>
                                <Button style={{color:"#1f36c7", border:"none"}} icon={<CloseOutlined />} onClick={()=>onFilterClear("Function")}></Button>
                              </div>
                          </div>}
                          <Radio.Group onChange={()=> {}} style={{width: "100%"}} value={filterRadio.catalog_products}>
                            <Space direction="vertical" style={{width: "100%"}}>
                              {functionFilters?.map((item, idx) => {
                                  return <>
                                    <div className="radio-items" style={{display:'flex', justifyContent: "space-between"}}>
                                      <Radio className="radio" style={{width: "75%"}} value={item.function_name} onClick={(e)=> {addTofilters(e, "catalog_products", item.function_name); setFunctionIcon(item.function_name);}} >{item.function_name}</Radio>
                                      <div className="action-buttons" style={{width: "22%"}}>      
                                        <Button style={{color:"#1f36c7", border:"none"}} icon={<EditOutlined />} onClick={()=> onFilterEdit("Function", item)}></Button>
                                        <Button style={{color:"red", border:"none"}} icon={<DeleteOutlined />} onClick={()=>deleteFunctionFilter(item.function_id)}></Button>
                                      </div>
                                    </div>
                                  </>
                              })}
                            </Space>
                          </Radio.Group>
                        </Panel>
                        <Panel header="Sub Area" key="3" >
                        { !addEditSubAreaFlag && <div style={{height:50, width:"100%", display: "flex", justifyContent: "end"}}>
                          <Button color="primary" style={{color:"#1f36c7", border:"none"}} icon={<PlusOutlined />} onClick={()=>onFilterAdd("sub_area")}> Add SubArea </Button>
                        </div> } 
                        {addEditSubAreaFlag && <div className="add-filters" style={{height:50, width:"100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                              <div className="add-filters-input" style={{width: "75%"}}>
                                  <input placeholder="Enter Sub Area" style={{width: "100%", padding: "2px 15px", borderRadius: 5}} type={"text"} value={addEditSubArea.sub_area} onChange={(e)=> {setAddEditSubArea(old=> ({...old, "sub_area": e.target.value}))}}/>
                              </div>
                              <div className="add-filters-action" style={{width: "22%"}}>
                                <Button style={{color:"#1f36c7", border:"none"}} icon={<SaveOutlined />} onClick={()=>onFilterSave("sub_area")}></Button>
                                <Button style={{color:"#1f36c7", border:"none"}} icon={<CloseOutlined />} onClick={()=>onFilterClear("sub_area")}></Button>
                              </div>
                          </div>}
                          <Radio.Group onChange={()=> {}} style={{width: "100%"}} value={filterRadio.sub_area}>
                            <Space direction="vertical" style={{width: "100%"}}>
                              {subAreaFilters?.map((item, idx) => {
                                  return <>
                                    <div className="radio-items" style={{display:'flex', justifyContent: "space-between"}}>
                                      <Radio className="radio" style={{width: "75%"}} value={item.sub_area} onClick={(e)=> addTofilters(e, "sub_area", item.sub_area)}>{item.sub_area}</Radio>
                                      <div className="action-buttons" style={{width: "22%"}}>      
                                        <Button style={{color:"#1f36c7", border:"none"}} icon={<EditOutlined />} onClick={()=> onFilterEdit("sub_area", item)}></Button>
                                        <Button style={{color:"red", border:"none"}} icon={<DeleteOutlined />} onClick={()=>deleteSubAreaFilter(item.sub_area_id)}></Button>
                                      </div>
                                    </div>
                                  </>
                              })}
                            </Space>
                          </Radio.Group>
                        </Panel>
                      </Collapse>
                      </div>
                      }
                    {/* <div>
                      <p className="mb-3 mt-5">Cluster</p>
                      <div className="row">
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" className="mr-1" />
                            <label for="vehicle1">Europe</label>
                          </div>
                        </div>
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle2" name="vehicle2" value="Bike" className="mr-1" />
                            <label for="vehicle2">Europe</label>
                          </div>
                        </div>
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle3" name="vehicle3" value="Bike" className="mr-1" />
                            <label for="vehicle3">Europe</label>
                          </div>
                        </div>
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle4" name="vehicle3" value="Bike" className="mr-1" />
                            <label for="vehicle4">Europe</label>
                          </div>
                        </div>
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle5" name="vehicle3" value="Bike" className="mr-1" />
                            <label for="vehicle5">Europe</label>
                          </div>
                        </div>
                      </div>
                      <p className="mb-3 mt-5">Status</p>
                      <div className="row">
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle6" name="vehicle1" value="Bike" className="mr-1" />
                            <label for="vehicle6">Status</label>
                          </div>
                        </div>
                      </div>
                      <p className="mb-3 mt-5">Catalogue Products</p>
                      <div className="row">
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle11" name="vehicle1" value="Bike" className="mr-1" />
                            <label for="vehicle11">Europe</label>
                          </div>
                        </div>
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle12" name="vehicle2" value="Bike" className="mr-1" />
                            <label for="vehicle12">Europe</label>
                          </div>
                        </div>
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle13" name="vehicle3" value="Bike" className="mr-1" />
                            <label for="vehicle13">Europe</label>
                          </div>
                        </div>
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle14" name="vehicle3" value="Bike" className="mr-1" />
                            <label for="vehicle14">Europe</label>
                          </div>
                        </div>
                        <div className="col-4 mb-2">
                          <div className={`${styles.checlk_list}d-flex`}>
                            <input type="checkbox" id="vehicle15" name="vehicle3" value="Bike" className="mr-1" />
                            <label for="vehicle15">Europe</label>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>}
                {/* Added Add button */}
          
                <div className="col-md-9">
                <div className="row">
                  <div className={"col-md-8"}></div>
                  {
                    props.userRole === "admin" && <div className={"col-md-4"} style={{paddingLeft:"100px", paddingBottom:"30px"}}>
                      <span
                        style={{minWidth:"135px", height:"39px",padding:"8px 16px", borderRadius:"4px", fontSize:"15px", fontWeight:400, color:"#ffffff", backgroundColor:"#1F36C7", cursor:"pointer"}}
                        onClick={()=>setAddProduct(true)}
                      >
                        <img src={"../../assets/svg/add.svg"} alt="" className="position-relative" color="#FFF" style={{paddingRight:"5px",display:"inherit"}} />Add Product
                      </span>
                    </div>
                  }
                      <div className={"col-md-1"}></div>
                  </div>
                   {!isHidden &&  
                  <div className="row">
                    {allProducts.length > 0 && allProducts.map((va) => {
count++;                
pagenumber=(currentPage*9-9)+count

      return (
                        <div className={`${styles.cardHead} col-md-4`}>
    <div className={styles.cardBody} style={{ height: "11rem" }}>
        <div className="d-flex">
            <div>
                <p className={`${styles.para} ${styles.title}`} style={{paddingBottom:"0", marginTop:"10px"}}>S{pagenumber} {va.pid} {va.product_title}</p>
                                <p className={styles.content1} style={{fontSize:"12px"}}>
                                  {va.product_caption}
                                  {/* {va.product_caption.length <= 120 ? `${va.product_caption.substring(0, 120)}` : `${va.product_caption.substring(0, 120)}`}
                                  {va.product_caption.length <= 120 ? "" : "...." }

                                  <button className={styles.btn} onClick={() => setShowMore(!showMore)}>

                                  {va.product_caption.length <= 120 ? <p className=""  onClick={() => goToPage(va.product_id)}></p> : <p className=""  onClick={() => goToPage(va.product_id)}>more</p>}
                                  </button> */}
                                </p>
            </div>
            <div>
                {/* <img src={`${imageBaseURL + va.product_banner}`} alt="" className="position-relative " /> */}
                <img src={`${imageBaseURL + va.product_banner}`} alt="" className="position-relative " />
            </div>
        </div>

    </div>
    <div className={`${styles.cardFoot} d-flex align-items-center justify-content-between` }
        style={{backgroundColor: "#E9EDF3" , padding: " 0px 10px", height:"64px" }}>
        <div style={{ display: "flex" ,alignItems:"baseline", paddingRight: 8 }}>
            <div className="mr-2">
                <img src={`${imageBaseURL}product-data.svg`} alt="" />
            </div>
            <div>
                <p className={`${styles.content}`} style={{fontSize:"12px"}}>
                    {va.hrs_saved} {va.hrs_saved_text}
                </p>
            </div>
        </div>

        <img style={{cursor:"pointer"}} src={`${imageBaseURL}bg_white_arrow.svg`} alt="" className="position-relative "
            onClick={()=> goToPage(va.product_id)}/>
    </div>
</div>
                      )
                    })}
                  </div>}
                </div>
              </div>
            </main>
            {/* {parseInt(totalPage) > 0 && (
              <div class={styles.pagination}>
                <a href={() => void (0)} style={(parseInt(currentPage) == 1) ? { backgroundColor: '#ddd', pointerEvents: 'none', cursor: "not-allowed" } : { background: 'white',cursor:"pointer" }} onClick={() => setCurrentPage((v) => parseInt(v) - 1)}>&laquo;</a>
                {page?.map((v) => {
                  return (
                    <a href={() => void (0)} onClick={() => setCurrentPage(v)} style={(parseInt(currentPage) == parseInt(v)) ? { backgroundColor: '#1F36C7', color: "white", border: '1px solid #1F36C7',borderRadius: '4px' } : { backgroundColor: '#fff',borderRadius: '4px',cursor:"pointer" }} className={(parseInt(currentPage) == parseInt(v)) && 'active'}>{v}</a>
                  )
                })}
                <a href={() => void (0)} style={(parseInt(currentPage) == (page?.length)) ? { backgroundColor: '#ddd', pointerEvents: 'none', cursor: "not-allowed" } : { background: 'white',cursor:"pointer" }} onClick={() => setCurrentPage((v) => parseInt(v) + 1)}>&raquo;</a>
              </div>
            )}*/}
          </div>
          <div className={styles.mainSection_space}>
            {!isHidden &&   <div className={styles.Products_section}>
              <h1>Introduction To Products</h1>
              {/* <p>We’ve over 30+ live products across 8 clusters</p> */}
              {/* <img src={`${imageBaseURL}intro_product.mp4`} alt="" /> */}
              <div className={styles.iframe_section} dangerouslySetInnerHTML={{ __html: `<iframe src=${imageBaseURL}intro_product.mp4 pused/>` }} />

            </div>}
            <div className={`${styles.Products_section}`}>
              <div className={styles.Section_2}>
                <div className="row">
                  <div className="col-md-6 col-6">
                    <h1>Always happy to help you.</h1>
                    <p>Email us your question or quaries and we would be happy to answer by seting up a call with you.</p>
                    <button>
                      Get in touch with us
                    </button>
                  </div>
                  <div className="col-md-6 col-6" style={{ textAlign: "center" }}>
                    <img src={`${imageBaseURL}product_user.png`} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>}
        {/* </InfiniteScroll> */}
      </div>
      : <Addproduct key={infiniteKey} setAddProduct={setAddProduct} onSuccess={()=>{setAddProduct(false);location.reload()}} isAdd={true}/>}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    storeProduct: state.storeProduct,
  };
};

export default connect(mapStateToProps, null)(index);


